import React, { useState, FormEvent } from 'react';
import { Button } from '@/components/ui/button';
import { getCallable } from '@/config/firebase';
import { toast as sonnerToast } from 'sonner';
import { Loader2 } from 'lucide-react';

export const NewsletterCTA: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      sonnerToast.error('Please enter a valid email.');
      return;
    }

    setIsLoading(true);
    try {
      const subscribeFn = await getCallable('subscribeToNewsletter');
      await subscribeFn({ email, source: 'blog_index_cta' });
      
      sonnerToast.success('Thanks for subscribing!');
      setEmail('');
    } catch (error: any) {
      console.error('Subscription error:', error);
      sonnerToast.error(error.message || 'Failed to subscribe. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-primary/5 py-24 border-y border-primary/10">
        <div className="container px-4 text-center max-w-2xl mx-auto">
            <h2 className="text-3xl font-bold mb-4">Stay compliant. Stay profitable.</h2>
            <p className="text-muted-foreground mb-8">Join 2,000+ environmental consultants and site managers receiving our weekly compliance tips.</p>
            <form className="flex gap-2 max-w-md mx-auto" onSubmit={handleSubscribe}>
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="flex-1 h-12 px-4 rounded-full border border-border bg-background focus:ring-2 focus:ring-primary focus:outline-none" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                />
                <Button size="lg" className="rounded-full px-8" disabled={isLoading}>
                  {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Subscribe'}
                </Button>
            </form>
        </div>
    </div>
  );
};
